exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.summary-card[data-v-664977b8] { border-radius: 6px;\n}\n@media print {\n.card[data-v-664977b8] { box-shadow: none !important; border: 1px solid #d8dee9;\n}\n.table[data-v-664977b8] { font-size: 10px;\n}\n}\n", ""]);

// exports
